import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './Header.css';

const Header = () => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="admin-header">
      <div className="header-content">
        <div className="header-logo">
          <img src="/logo.jpeg" alt="Essentique Admin" className="logo-image" />
        </div>
        <div className="header-actions">
          <span className="admin-name">{user?.full_name || user?.email}</span>
          <button onClick={handleLogout} className="logout-btn">
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
